'use strict';

var React = require('react');

var SvgChartCohortIcon = function SvgChartCohortIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4.5 3.25c-.69 0-1.25.56-1.25 1.25v11c0 .69.56 1.25 1.25 1.25h3c.69 0 1.25-.56 1.25-1.25v-2.75h2.75c.69 0 1.25-.56 1.25-1.25v-2.75h2.75c.69 0 1.25-.56 1.25-1.25v-3c0-.69-.56-1.25-1.25-1.25h-11Zm4.25 8h2.5v-2.5h-2.5v2.5Zm-4 1.5v2.5h2.5v-2.5h-2.5Zm0-1.5h2.5v-2.5h-2.5v2.5Zm6.5-4h-2.5v-2.5h2.5v2.5Zm-6.5 0h2.5v-2.5h-2.5v2.5Zm10.5 0h-2.5v-2.5h2.5v2.5Z"
  }));
};
SvgChartCohortIcon.displayName = "ChartCohortIcon";

exports.SvgChartCohortIcon = SvgChartCohortIcon;
